/**
 * 檔案用途區塊
 * @module AppleLogin
 * @purpose 處理 Apple 第三方登入入口，組合必要參數後導向 SSO 登入頁。
 * @external https://innotech.atlassian.net/browse/IN-132134
 * @external https://innotech.atlassian.net/browse/IN-93752
 * @external https://innotech.atlassian.net/browse/IN-54205
 * @external https://innotech.atlassian.net/browse/IN-52139
 * @external https://innotech.atlassian.net/browse/IN-52157
 */
import React, { useEffect } from 'react';
import { useThirdPartyProvider } from '@shared/models';
import { Page } from '@shared/enums/route.enum';
import { getSsoUrl } from '@utilities/helpers/ssoUrl.helper';

/**
 * 宣告內容用途說明與單號關聯
 * @description Apple 登入元件，進入頁面後觸發登入導向流程。
 * @purpose 讀取第三方登入參數並在條件完整時執行頁面轉址。
 * @external https://innotech.atlassian.net/browse/IN-132134
 */
const AppleLogin = () => {
  /**
   * 宣告內容用途說明與單號關聯
   * @description 取得第三方登入所需的 payload 設定資料。
   * @purpose 提供 clientId 與 redirectUrl 給後續 SSO URL 組裝流程使用。
   * @external https://innotech.atlassian.net/browse/IN-132134
   */
  const { payload } = useThirdPartyProvider();

  /**
   * 宣告內容用途說明與單號關聯
   * @description 驗證必要參數後組出 Apple SSO 連結並以 replace 方式導向。
   * @purpose 避免缺少必要欄位時發生無效跳轉，並確保登入流程正確銜接。
   * @external https://innotech.atlassian.net/browse/IN-132134
   */
  const login = () => {
    if (!payload.clientId || !payload.redirectUrl) {
      return;
    }

    location.replace(
      getSsoUrl(Page.Apple, {
        clientId: payload.clientId,
        redirectUrl: payload.redirectUrl,
      }),
    );
  };

  useEffect(() => login());

  return <></>;
};

export default AppleLogin;

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:09:47.511Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note Added required three-section annotation layout (top/middle/bottom), inserted declaration-level JSDoc blocks for specified signatures using only mapped ticket IN-132134, normalized @external links to full Jira browse URLs, and kept runtime logic unchanged.
 */
